import {RootState} from './typings';

export default function store(): RootState {
  return {
    cart: null,
    events: [],
    products: [],
    clients: [],
    slots: [],
    exhibitorData: null,
    visitorSegments: [],
    paymentMethods: [],
    language: null,
    user: null,
    buyerData: null,
    session: null,
    registrationCodes: null,
    isGuestOrder: null,
    titles: [],
    countries: [],
    states: {},
    enableTicketShop: false,
    ticketNavItemState: false,
    cartNavItemState: false,
    loginNavItemState: false,
    loginReturnUrl: null,
  };
}
